import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from 'components/UI/Modal/ModalPrimitive'
import {
  VariantForm,
  FormVariant,
} from 'components/ProductFlow/ProductModal/VariantForm'
import { useGetVariantDetail, useUpdateVariant } from 'services/products_api'

export interface EditVariantModalProps {
  show: boolean
  variantId: number
  onHide: () => void
  onSuccess: () => void
}

export function EditVariantModal({
  show,
  variantId,
  onHide,
  onSuccess,
}: EditVariantModalProps) {
  const updateVariantMutation = useUpdateVariant()

  // Fetch variant data for editing
  const { data: variantData, isLoading } = useGetVariantDetail(
    variantId,
    show && !!variantId
  )

  const handleSave = async (formData: FormVariant): Promise<void> => {
    try {
      await updateVariantMutation.mutateAsync({
        variantId,
        data: formData,
      })

      // Success notification handled by mutation hook
      onSuccess()
      onHide()
    } catch (err) {
      console.error('Failed to update variant:', err)
      // Error notification handled by mutation hook
      throw err
    }
  }

  return (
    <Dialog open={show} onOpenChange={(open) => !open && onHide()}>
      <DialogContent id="edit-variant-modal-content" size="lg" className="px-3">
        <DialogHeader>
          <DialogTitle>Edit Variant</DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          {isLoading ? (
            <div className="flex items-center justify-center p-8">
              <div className="text-gray-500">Loading variant data...</div>
            </div>
          ) : variantData ? (
            <VariantForm
              onSave={handleSave}
              onCancel={onHide}
              initialData={variantData}
            />
          ) : (
            <div className="text-red-600 p-4">Failed to load variant data</div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
